import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import "./MobileTopBar.css";
import appIconWhite from "../assets/appIcon.svg";
import appIconBlue from "../assets/socialPawsLogo.svg";

const MobileTopBar = ({
  onBack,
  backColor = "#fff",
  logoColor = "#fff",
  appName = "Social Paws",
  showLogo = true,
  showBackButton = true,
  blueLogo = false,
  className = "",
  isProtectedRoute = true,
}) => {
  const navigate = useNavigate();

  const handleLogoClick = () => {
    if (isProtectedRoute) {
      localStorage.setItem("dashboard_current_view", "map");
      navigate("/dashboard-switcher", { state: { resetFilter: true } });
    }
  };

  return (
    <div
      className={`common-mobile-header mobile-only ${className}`}
      style={{ justifyContent: showBackButton ? "space-between" : "flex-end" }}
    >
      {showBackButton && (
        <button className="common-back-btn" onClick={onBack}>
          <ArrowLeft size={22} color={backColor} strokeWidth={3} />
          <span style={{ color: backColor }}>Back</span>
        </button>
      )}

      {showLogo && (
        <div
          className="common-header-logo"
          style={{ color: logoColor }}
          onClick={handleLogoClick}
        >
          <img
            src={blueLogo ? appIconBlue : appIconWhite}
            alt={appName}
            className="common-logo-img"
          />
          <span>{appName}</span>
        </div>
      )}
    </div>
  );
};

export default MobileTopBar;
